import { useParams } from "react-router-dom";
import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import { useBoardViews } from "../../contexts/views/viewsContext";
import ViewTitle from "../../layout/components/ViewTitle";

export const FavoriteView = () => {
  const { viewId } = useParams();
  const { favoriteViews } = useBoardViews();

  const currentView = favoriteViews.find((v) => v.Id === viewId);

  return (
    <>
      <div>
        <ViewTitle
          viewId={currentView?.Id}
          viewName={currentView.Name}
          allowRenaming={!currentView?.IsSystemView}
          isFavoriteView={true}
        />
      </div>
      <div className="row">
        <TaskGrid
          viewId={currentView?.Id}
          enableSaveView={!currentView?.IsSystemView}
          viewType={currentView?.ViewType}
        />
      </div>
    </>
  );
};
